import { createSlice } from "@reduxjs/toolkit";

const bookingTable = createSlice({
  name: "bookingTable",
  initialState: {
    bookingTablePopup: false,
    bookingDetails: {
      bookings: [],
    },
    loading : false,
  
  },
  reducers: {
    setSelectedBookingTable: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetSelectedBookingTable: (state) => {
      return state = {
          bookingTablePopup: false,
          bookingDetails: {
            bookings: [],
          },
          loading: false,
      };
    },
    addNewBookingToDetails: (state, action) => {
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookings: [...state.bookingDetails.bookings, action.payload],
        },
      };
    },
    updateBookingStatusInDetails: (state, action) => {
      const { bookingId, newStatus } = action.payload;
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookings: state.bookingDetails.bookings.map((booking) =>
            booking.id === bookingId ? { ...booking, status: newStatus } : booking
          ),
        },
      };
    },
    updateBookingInDetails: (state, action) => {
      const payload = action.payload;
      if (!state.bookingDetails || !state.bookingDetails.bookings) return state;
      return {
        ...state,
        bookingDetails: {
          ...state.bookingDetails,
          bookings: state.bookingDetails.bookings.map((booking) => {
            if (booking.id !== payload.booking_id) return booking;
            return {
              ...booking,
              unique_id: payload.unique_id || booking.unique_id,
              reservation_date: payload.reservation_date || booking.reservation_date,
              start_time: payload.start_time || booking.start_time,
              end_time: payload.end_time || booking.end_time,
              guest: payload.guest !== undefined ? Number(payload.guest) : booking.guest,
              advance: payload.advance !== undefined ? Number(payload.advance) : booking.advance,
              status: payload.status || booking.status,
              table_status: payload.table_status || booking.table_status,
              customer: booking.customer ? {
                ...booking.customer,
                full_name: payload.customer_name || booking.customer.full_name,
              } : {
                full_name: payload.customer_name,
              }
            };
          }),
        },
      };
    },
  },
});

export const { setSelectedBookingTable, resetSelectedBookingTable, addNewBookingToDetails, updateBookingStatusInDetails, updateBookingInDetails } = bookingTable.actions;

export default bookingTable.reducer;